// extracted by mini-css-extract-plugin
export default {"stepper":"TerminalPagos_stepper__hugdt"};